<template>
  <div class="page">
    <!-- :bodyStyle="{padding:'12px'}" -->
    <a-card title="账户概览" :bordered="false" :bodyStyle="{paddingTop:'0px'}"
            :headStyle="{borderBottom:'0px',fontSize:'18px'}">
      <a-row>
        <a-col style="text-align:right;"><a @click="goAccSetting">收款账户设置</a></a-col>
      </a-row>
      <div class="table-header">
        <div class="item-content">
          <div class="title-text">
            <span>账户余额(元)</span>
            <a @click="toIncomeExpend">查看收支明细</a>
          </div>
          <div class="price">
            <span>{{ merchantInfo.accountTotal }}</span>
          </div>
          <div class="withdraw-price">含可提现及提现中金额：{{ merchantInfo.accountExtractAmount }}</div>
        </div>
        <div class="item-content" v-if="!independentPay">
          <div class="title-text">
            <span>可提现金额(元)</span>
          </div>
          <div class="price">
            <span>{{ merchantInfo.accountAbleDrawCash }}</span>
            <a-button @click="toBalanceRecharge" type="primary" v-if="merchantType!=3">充值</a-button>
          </div>
          <div class="withdraw-price">
            <span>提现中冻结：{{ merchantInfo.accountFrozenAmount }}</span>
            <a-button @click="toExtractMoney">提现</a-button>
          </div>
        </div>
        <div class="item-content" v-if="!independentPay&&merchantType!=3">
          <div class="title-text">
            <span>授信余额(元)</span>
          </div>
          <div class="price">
            <span>{{ merchantInfo.accountCreditAmt }}</span>
          </div>
          <div class="withdraw-price active">
            <span>待还款：{{ merchantInfo.accountUsedCreditAmt }}</span>
            <a-button @click="toCreditPayment">还款</a-button>
          </div>
        </div>
      </div>
      <a-card :bordered="false" :bodyStyle="{padding:'0px'}" :headStyle="{borderBottom:'0px',paddingLeft:'0px'}">
        <a-row slot="title">
          <a-col :span="8">
            <span class="card-title">提现记录</span>
          </a-col>
        </a-row>
        <custom-page-table
          ref="table"
          rowKey="drawcashCreateTime"
          :columns="columns"
          :queryParams="queryParams"
          :requestPromise="loadPromise"
        >
            <span slot="drawcashStatus" slot-scope="rowItem">
              {{ rowItem.text|applyStatusName }}
            </span>
        </custom-page-table>
      </a-card>
    </a-card>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AccountDetails',
  data() {
    return {
      queryParams: {},
      merchantInfo: {
        accountTotal: 0,
        accountExtractAmount: 0,
        accountAbleDrawCash: 0,
        accountFrozenAmount: 0,
        accountCreditAmt: 0,
        accountUsedCreditAmt: 0
      },
      loadPromise: params => this.getRecordData(params),
      columns: [
        {
          title: '提交时间',
          dataIndex: 'drawcashCreateTime'
        },
        {
          title: '金额(元)',
          dataIndex: 'drawcashAmount'
        },
        {
          title: '银行账号',
          dataIndex: 'drawCashMyBank'
        },
        {
          title: '状态',
          dataIndex: 'drawcashStatus',
          scopedSlots: { customRender: 'drawcashStatus' }
        },
        {
          title: '未通过原因',
          dataIndex: 'drawcashNopassCause'
        }
      ],
      merchantType: 3
    }
  },
  computed: {
    ...mapState({
      independentPay: state => state.user.independentPay
    })
  },
  mounted() {
    this.getmerchantFinanceInfo()
    this.merchantType = this.$store.getters.merchantField.merchantType
  },
  methods: {
    toIncomeExpend() {
      this.$router.push({
        name: 'IncomeExpend'
      })
    },
    toBalanceRecharge() {
      this.$router.push({
        name: 'BalanceRecharge'
      })
    },
    toCreditPayment() {
      this.$router.push({
        name: 'CreditPayment'
      })
    },
    toExtractMoney() {
      this.$router.push({
        name: 'ExtractMoney'
      })
    },
    //获取商户信息
    getmerchantFinanceInfo() {
      this.getHttpServices().getUserService().post('finance/account/get/merchantFinanceInfo')
        .then(res => {
          this.merchantInfo = res
          this.getLogUtils().logWithTag('merchantFinanceInfo', res)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    getRecordData(params) {
      return this.getHttpServices().getUserService().post('finance/account/get/withdrawDetail', params)
    },
    goAccSetting() {
      this.$router.push({
        name: 'AccountSetting'
      })
    }
  }

}
</script>
<style scoped lang="less">
.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.image-table {
  width: 120px;
  height: 40px;

  img {
    width: 120px;
    height: 40px;
  }
}

.table-header {
  background: #f5f5f5;
  padding: 10px 15px;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;

  .item-content {
    width: 250px;
    font-size: 14px;
    font-weight: 500;

    .title-text {
      display: flex;
      font-weight: 500;
      color: #000;

      span {
        padding-right: 15px;
      }
    }

    .price {
      color: #FF7300;
      font-weight: bold;
      font-size: 18px;
      display: flex;
      align-items: flex-end;
      height: 32px;
      margin-bottom: 5px;

      span {
        line-height: 20px;
        min-width: 150px;
        padding-right: 10px;
      }
    }

    .withdraw-price {
      color: #8f8f8f;
      font-size: 12px;
      height: 32px;
      line-height: 32px;
      display: flex;

      span {
        min-width: 150px;
        padding-right: 10px;
      }
    }

    .active {
      span {
        min-width: 90px !important;
      }

    }
  }
}
</style>